import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { Plus, Minus } from "lucide-react";

export function Faq({ items, title = "Frequently asked questions", testidPrefix = "faq" }) {
  const [open, setOpen] = useState(0);
  return (
    <div>
      {title && <h2 className="font-serif font-light text-3xl md:text-5xl tracking-tight mb-12">{title}</h2>}
      <div className="border-t border-white/15">
        {items.map((it, i) => (
          <Reveal key={i} delay={i * 0.03}>
            <div className="border-b border-white/15" data-testid={`${testidPrefix}-item-${i}`}>
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`${testidPrefix}-toggle-${i}`}
                className="w-full flex items-start justify-between gap-6 py-6 text-left group"
              >
                <span className="font-serif text-xl md:text-2xl font-light group-hover:text-gold transition-colors">{it.q}</span>
                <span className="shrink-0 mt-1 text-gold">{open === i ? <Minus size={20} /> : <Plus size={20} />}</span>
              </button>
              <div className={`overflow-hidden transition-all duration-500 ${open === i ? "max-h-96 opacity-100 pb-8" : "max-h-0 opacity-0"}`}>
                <p className="text-muted2 leading-relaxed max-w-3xl pr-10">{it.a}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
